import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'
import { Field } from 'redux-form'

import './ServiceInstructions.scss'
import MobileNavBar from 'components/MobileNavBar'
import { serviceTypes } from '@src/globals'

class ServiceInstructions extends Component {
  constructor (props) {
    super(props)

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit (data) {
    const {
      updateRecurrence,
      updateService,
      goBack,
      bookingId,
      serviceTypeId
    } = this.props

    if (serviceTypeId === serviceTypes.WEEKLY.id) {
      updateRecurrence(bookingId, data)
    } else if (serviceTypeId === serviceTypes.ONE_TIME.id) {
      updateService(bookingId, data)
    } else {
      goBack()
      return false
    }

    goBack()
  }

  render () {
    const {
      handleSubmit,
      goBack
    } = this.props

    return (
      <div className='ServiceInstructions navbar-screen'>
        <MobileNavBar
          leftControl={
            <Link onClick={goBack}>
              <span className='icon-cross' />
            </Link>
          }
          rightControl={<i className='icon-logo' />}
        >
          Instrucciones adicionales
        </MobileNavBar>

        <div className='ServiceInstructions-content navbar-screen-content'>
          <div className='navbar-screen-container'>
            <form onSubmit={handleSubmit(this.handleSubmit)} className='ServiceInstructions-form'>
              <Field
                name='specialInstructions'
                component='textarea'
                type='text'
                rows={6}
                className='ServiceInstructions-textarea'
                placeholder='Escribe instrucciones adicionales para tu aliada' />

              <div className='ServiceInstructions-save'>
                <button
                  type='submit'
                  className='btn btn-primary btn-block btn-lg'>
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}
ServiceInstructions.displayName = 'ServiceInstructions'
ServiceInstructions.propTypes = {
  updateRecurrence: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired
}

export default ServiceInstructions



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceInstructions/ServiceInstructions.js